import React from "react";
import { Pressable, Text, View } from "react-native";
import Modal from "react-native-modal";
import CloseIcon from "@/assets/svgs/close-icon";
import WarningIcon from "@/assets/svgs/warning-icon";
import ResponsiveContent from "../shared/responsive-content";
import { Button } from "../ui/button";

function RequestSentModal({
  isVisible,
  onClose,
  onDismiss,
}: {
  isVisible: boolean;
  onClose: () => void;
  onDismiss: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={() => {
        onDismiss();
      }}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 py-10">
          <View className="items-end">
            <Pressable
              onPress={onClose}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black">
              Your lesson request has been sent.
            </Text>

            <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
              {`Your credits have been temporarily reserved. Your request will be automatically cancelled and no credits will be used, if the tutor doesn't respond within 48 hours.`}
            </Text>

            <View className="flex-row items-start gap-2 rounded-md bg-yellow-100 px-4 py-3 border border-yellow-300">
              <WarningIcon pathClassName="fill-yellow-500" className="size-6" />

              <Text className="text-sm font-geologica-regular font-normal leading-[1.5] text-yellow-800">
                Important: To participate in the lesson, please access the
                student's account at the time of the call.
              </Text>
            </View>

            <Button fullWidth size="md" intent="primary" onPress={onClose}>
              <Button.Text size="md">Okay</Button.Text>
            </Button>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default RequestSentModal;
